import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  container: {
    width: "100%",
    marginHorizontal: "auto",
    minHeight: "100%",
    flexGrow: 1,
    gap: {
      xs: spacing(6),
      lg: spacing(10),
    },
    flexDirection: {
      xs: "column",
      lg: "row",
    },
  },
  menu: {
    flexDirection: "column",
    gap: spacing(8),
    flexBasis: spacing(120),
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: {
      lg: spacing(120),
    },
  },
  menuItems: {
    gap: spacing(8),
    flexDirection: "column",
    flexGrow: 1,
  },
  menuGroupTitle: {
    marginBottom: spacing(4),
  },
  menuFooter: {
    justifyContent: "flex-end",
    gap: spacing(4),
    _web: {
      position: "sticky",
      bottom: spacing(20),
    },
  },
  content: {
    gap: spacing(6),
    paddingTop: spacing(2),
    maxWidth: spacing(224),
    flex: 1,
  },
  toggleButtonBorderBottom: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: colors.borderDefault,
  },
  versionText: {
    color: colors.foregroundDefaultMuted,
    textAlign: "center",
  },
}));

export default stylesheet;
